import { client } from './client'

const getCompliance = async (cocap: string) => {
  const { data } = await client.get('/person/compliance/report', {
    headers: {
      cocap
    }
  })
  return data
}

export { getCompliance }
